/* @ngInject */
const accountRequest = (
  $q,
  $http,
  utils,
  $state,
  labels,
  authService,
  accountResource
) => {
  const self = {}

  self.getAll = () => {
    return $q((resolve, reject) => {
      accountResource.get({}, (res) => {
        resolve(res.data)
      }, (error) => {
        console.error(error)
      })
    })
  }

  self.getBySearch = (_data) => {
    return $q((resolve, reject) => {
      accountResource.post({
        action: 'search',
      }, _data, (res) => {
        if (res.success === false) {
          reject(res.data)
        }
        resolve(res.data)
      }, (error) => {
        console.error(error)
        reject(error)
      })
    })
  }

  self.register = (_username, _password, _admin = false) => {
    return $q((resolve, reject) => {
      accountResource.save({
        username: _username,
        password: _password,
        admin: _admin,
      }, (res) => {
        if (res.success) {
          resolve(res.message)
        }
        reject(res.message)
      }, (error) => {
        reject(error)
      })
    })
  }

  self.login = (_username, _password) => {
    return $q((resolve, reject) => {
      accountResource.post({
        action: 'login',
      }, {
        username: _username,
        password: _password,
      }, (res) => {
        console.log(res)
        if (res.success) {
          authService.saveToken(res.data.token)
          authService.saveUsername(_username)
          authService.saveUid(res.data.user.id)
          $http.defaults.headers.common.Authorization = res.data.token

          $state.reload()
          resolve(res.message)
        } else {
          reject(res.message)
        }
      }, (error) => {
        if (error.status === 401) {
          reject(`Impossible de se connecter, identifiant ou mot de passe incorrect`)
        }
        reject(labels.error.server(error.status), error)
      })
    })
  }

  self.changePassword = (_username, _oldPassword, _newPassword) => {
    return $q((resolve, reject) => {
      accountResource.post({
        action: 'change-password',
      }, {
        username: _username,
        oldPassword: _oldPassword,
        newPassword: _newPassword,
      }, (res) => {
        if (res.success) {
          resolve(res.message)
        } else {
          if (res.code === -1) {
            authService.logout()
          }
          reject(res.message)
        }
      }, (error) => {
        reject(labels.error.server(error.status), error)
      })
    })
  }

  self.delete = (_id) => {
    console.log(_id)
    return $q((resolve, reject) => {
      accountResource.delete({
        action: _id,
      }, (res) => {
        if (res.success) {
          if (_id === authService.getUsername()) {
            authService.logout()
          }
          resolve(res.message)
        } else {
          if (res.code === -1) {
            authService.logout()
          }
          reject(res.message)
        }
      }, (error) => {
        reject(labels.error.server(error.status), error)
      })
    })
  }

  return self
}

export default accountRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/services/request.service.js